module.exports = __webpack_public_path__ + "static/media/cash-for-junk-car-ipswich.e799faa5.png";